import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { OpenGraphMetadata } from "./interfaces/get-open-graph-metadata";

export async function getOpenGraphMetadata(
  url: string,
  env: Environment
): Promise<OpenGraphMetadata | null> {
  try {
    const endpoint = `${getBaseUrl(
      env
    )}cxm/media/open-graph-metadata?url=${encodeURIComponent(url)}`;
    const header = await getHeader();

    const response = await fetchWrapper.getAsync<OpenGraphMetadata>(
      endpoint,
      header
    );

    if (response && !response.hasError && response.data) {
      return response.data;
    }

    return null;
  } catch {
    return null;
  }
}
